import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { UserInteractionFields } from '../entities';
import { updateFieldInteraction, updateVideoSoundPreference } from '../store/actions';
import { getIsVideoSoundEnabled, getUserInteraction } from '../store/selectors';

export const useUserInteraction = () => {
  const dispatch = useDispatch();
  const userInteraction = useSelector(getUserInteraction);
  const isVideoSoundEnabled = useSelector(getIsVideoSoundEnabled);

  const doUpdateFieldInteraction = useCallback(
    (dataKey: UserInteractionFields) => {
      dispatch(updateFieldInteraction(dataKey));
    },
    [dispatch],
  );

  const doUpdateVideoSoundPreference = useCallback(
    (isEnabled: boolean) => {
      dispatch(updateVideoSoundPreference(isEnabled));
    },
    [dispatch],
  );

  return {
    updateFieldInteraction: doUpdateFieldInteraction,
    updateVideoSoundPreference: doUpdateVideoSoundPreference,
    userInteraction,
    isVideoSoundEnabled,
  };
};
